import React from 'react';
import { message } from 'antd';
import { createStore } from 'api/store';
import { Store } from 'api/types/store';
import StoreModal, { StoreModalProps } from '../StoreModal';
import { useSignedUser } from 'api/auth';

interface Props extends Omit<StoreModalProps, 'onSubmit'> {
  onSuccess?: (store: Store) => void;
}

export default function NewStore({ onSuccess = () => null, ...rest }: Props) {
  const { data: user } = useSignedUser();
  const handleSubmit = (values) => {
    return createStore({ owner: user.owner_id, country: 'US', ...values })
      .then((res) => {
        if (res.ok) {
          onSuccess(res.data);
          return;
        }
        message.error(res.errors.fields?.[0]);
      })
      .catch(() => message.error('Ups there was an error, please try it later!'));
  };

  return <StoreModal mode="new" title="Create Store" onSubmit={handleSubmit} {...rest} />;
}
